<template>
  <VersionSelect v-if="plp_task_id" fluid>
    <template #content="{ data, readonly, onChange, onBlur, onCreate }">
      <ExpCommissionQuestions
        :key="formKey"
        :value="data"
        :readonly="readonly"
        :onCreate="onCreate"
        @change="onChange"
        @blur="onBlur"
      />
    </template>
  </VersionSelect>
</template>

<script>
import { mapGetters } from 'vuex'
import VersionSelect from '@/components/VersionSelect'
import ExpCommissionQuestions from '@/components/expCommissionQuestions/ExpCommissionQuestions'

export default {
  name: 'MedicineCommissionQuestions',
  components: { VersionSelect, ExpCommissionQuestions },
  computed: {
    ...mapGetters(['plp_task_id', 'subExpertiseUUID']),
    formKey() {
      return `${this.plp_task_id || ''}-${this.subExpertiseUUID || 'new'}`
    },
  },
}
</script>
